export const keyBy = <T extends { [key: string]: any }>(arr: T[], keyProp: keyof T): { [key: string]: T } => {
  const hash: { [key: string]: T } = {};
  for (const item of arr) hash[item[keyProp]] = item;
  return hash;
};

/**
 * Removes duplicates from an array of objects based on a specific value of a key within that object.
 * Keeps the first occurence of each object in the output array.
 */
export const removeDuplicatesByKey = <ObjectType, T = { [key: string]: ObjectType }>(arr: T[], key: keyof T): T[] => {
  const seenKeys = new Set();
  const output: T[] = [];

  for (const item of arr) {
    if (seenKeys.has(item[key])) continue;
    seenKeys.add(item[key]);
    output.push(item);
  }

  return output;
};
